import React from "react";
import { Observer, observer } from "mobx-react-lite";
import { IApplicationContext } from "../context";
import { Alert } from "@blueprintjs/core";

/**
 * SignupFormActions
 */
export const SignupFormActions: React.FunctionComponent<IApplicationContext> = (props) => {
	return (
		<div className='signup-actions'>
			<Observer
				render={() => (
					<button
						className='uk-button uk-button-large uk-button-primary'
						disabled={!props.store.data.canSubmit || props.store.data.isBusy}
						onClick={props.store.data.submit}
					>
						Signup
					</button>
				)}
			/>

			<SignedUpModal {...props} />
		</div>
	);
};

// SignedUpModal
const SignedUpModal: React.FunctionComponent<IApplicationContext> = observer((props) => {
	const redirectToLogin = () => {
		location.assign(props.store.data.redirectUrl);
	};

	// --

	return (
		<Alert isOpen={!!props.store.data.signedUpMessage} intent='success' icon='tick-circle' confirmButtonText='Continue' onConfirm={redirectToLogin}>
			<h3 className='ui-font-raleway'>Account created</h3>

			<p>Your account has been created, it's now time to get rocking!</p>
		</Alert>
	);
});
